import React from "react";
import { Box } from "@mui/material";

export function CategoryLanguageInputs({
  currentLanguage,
  languagesList,
  names,
  setNames,
  isAiLoading,
  handleGenerateWithIA,
}) {
  const currentLangLabel = languagesList.find((l) => l.value === currentLanguage)?.label;

  return (
    <Box style={{ display: "flex", flexDirection: "column", gap: "6px", border: "1px solid #cbd5e1", borderRadius: "8px", padding: "12px", backgroundColor: "#f8fafc" }}>
      <Box style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <label style={{ fontSize: "0.82rem", fontWeight: "700", color: "#1e293b" }}>
          4. Nome da Categoria ({currentLangLabel}) *
        </label>
        <button
          type="button"
          disabled={isAiLoading || !names[currentLanguage]}
          onClick={handleGenerateWithIA}
          style={{
            padding: "4px 10px",
            backgroundColor: isAiLoading ? "#94a3b8" : "#0284c7",
            color: "#ffffff",
            border: "none",
            borderRadius: "6px",
            fontSize: "0.75rem",
            fontWeight: "700",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: "4px",
          }}
        >
          {isAiLoading ? "Gerando..." : "✨ Auto-Preencher IA"}
        </button>
      </Box>

      {languagesList.map(({ value: key, label }) => (
        currentLanguage === key && (
          <input
            key={key}
            type="text"
            required={key === "pt"}
            value={names[key] || ""}
            placeholder={`Ex: Atrações Naturais (${label})`}
            onChange={(e) =>
              setNames((state) => ({
                ...state,
                [key]: e.target.value,
                ...(key === "pt" ? { "pt-BR": e.target.value } : {}),
                ...(key === "en" ? { "en-US": e.target.value } : {}),
              }))
            }
            style={{
              width: "100%",
              padding: "8px 12px",
              border: "1px solid #cbd5e1",
              borderRadius: "6px",
              fontSize: "0.875rem",
              outline: "none",
              backgroundColor: "#ffffff",
              boxSizing: "border-box",
            }}
          />
        )
      ))}
    </Box>
  );
}
